import React from 'react';
import Layout from '../components/Layout';
import PageMeta from '../components/PageMeta';
import './PolicyPage.css';

const ShippingDelivery = () => {
  return (
    <Layout>
      <PageMeta
        title="Shipping & Delivery"
        description="FMultratech Farms Shipping & Delivery Policy. Order processing, international shipping, and delivery options in Nigeria."
      />
      <div className="policy-page">
        <div className="policy-hero">
          <h1>Shipping & Delivery Policy</h1>
          <p>FMultratech Farms</p>
        </div>
        <div className="policy-content">
          <div className="policy-container">
            <section className="policy-section">
              <h2>1. Order Processing and Production</h2>
              <p>
                Once a customer places an order and payment is successfully completed, FMUltratech Farms will review and submit the order to the designated factory or production partner for processing and manufacturing.
              </p>
              <p>
                Production timelines may vary depending on the nature of the product, order volume, and factory schedules.
              </p>
            </section>

            <section className="policy-section">
              <h2>2. International Shipping Process</h2>
              <p>
                After production is completed:
              </p>
              <ul>
                <li>The finished goods will be transferred from the factory to our designated shipping partner.</li>
                <li>The shipping company will handle international logistics and transportation from the country of origin to Nigeria.</li>
                <li>Once the shipping company receives the goods, relevant shipping information and package updates will be communicated to the customer where applicable.</li>
              </ul>
              <p>
                International shipping timelines may vary based on logistics conditions, customs processing, and other operational factors.
              </p>
            </section>

            <section className="policy-section">
              <h2>3. Arrival in Nigeria</h2>
              <p>
                Upon arrival in Nigeria:
              </p>
              <ul>
                <li>Customers will be notified once their goods have arrived and are available for collection.</li>
                <li>All shipments are received at the FMUltratech Farms Lagos warehouse located at Ajao Estate, Lagos Airport area.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Delivery and Pickup Options</h2>
              <p>
                Customers may choose from the following options for receiving their goods:
              </p>
              <h3>4.1 Personal Pickup</h3>
              <p>
                Customers may visit the Lagos warehouse location to pick up their goods in person.
              </p>
              <h3>4.2 Local Dispatch (Within Lagos)</h3>
              <p>
                Customers may request local delivery within Lagos. Dispatch arrangements and applicable delivery fees will be communicated where necessary.
              </p>
              <h3>4.3 Delivery Outside Lagos</h3>
              <p>
                Customers located outside Lagos may:
              </p>
              <ul>
                <li>Request that their goods be transported to a designated transport park or logistics provider for interstate delivery.</li>
                <li>The customer may also arrange their own preferred transport or logistics service.</li>
                <li>Any additional third-party transport arrangements outside Lagos may be subject to separate charges and policies.</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>5. Communication and Notifications</h2>
              <p>
                FMUltratech Farms will provide relevant updates regarding:
              </p>
              <ul>
                <li>Shipping status</li>
                <li>Arrival notifications</li>
                <li>Collection or delivery instructions</li>
              </ul>
              <p>
                Customers are responsible for ensuring their contact information is accurate and accessible.
              </p>
            </section>

            <section className="policy-section">
              <h2>6. Important Notes</h2>
              <ul>
                <li>Shipping timelines are estimates and may be affected by customs clearance, logistics delays, or other factors beyond our control.</li>
                <li>Customers are advised to collect goods promptly after notification to avoid storage complications.</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ShippingDelivery;
